import Header from "component/Header/Header";
import Footer from "component/Footer/Footer";
import React from "react";
import "./../index.scss";
import BlockHeader from "component/BlockHeader/BlockHeader";
import { InitiativeSlider } from "component/InitiativeList";
import { useEffect, useState } from "react";
import api from "api";
import Sidebar from "component/Sidebar";
import _ from "lodash";
import {ReactComponent as SVGResearchIcon} from '../../../../assets/icon-research.svg';
import { createSearchParams } from "react-router-dom";
import Breadcrumb from "component/Breadcrumb";
import { PageCredential } from "component/PageCredential";

const PageBrowseResearch = (props) => {

    const researchByTarget = [
        ['rnd'                   , 'Prototype R&D']
        ,['prototipe'            , 'Prototype Industry']
        ,['community-research'   , 'Research used by the community']
        ,['industry-product'     , 'Innovative products used by industry']
    ];

    const [researchField, setResearchField] = useState(false);

    const [basedTargetList, setBasedTargetList] = useState('rnd');
    const [basedFieldList, setBasedFieldList] = useState(false);

    useEffect(() => {
        api('/ResearchField', 'get', {
            posts_per_page : -1
        })
            .then(response => {
                setResearchField(response.field);
                if(response.field.length)
                {
                    setBasedFieldList(response.field[0].ResearchFieldID);
                }
            })
    }, []);
    
    return (
        <>
            <Header/>
            <PageCredential title={"Research Initiatives"}/>
            <div className="page-browse-brand --brand-research">
                <div className="page-brand-research relative color-white">
                    <div className="color-white container relative">
                        <h1 className="page-brand-title text-lg font-semibold">Research Activity</h1>
                        <div className="page-brand-desc leading-text mt-4 max-w-640">Collaboration between people from similar or other disciplines. Collaborative research help researcher to exchange ideas and create a higher research quality.</div>
                        <span className="page-brand-illustration image-box square contain">
                            <img src={process.env.PUBLIC_URL + '/assets/image/bridge/bridge-collaboration-illustration.png'} alt="Bridge Collab"   />
                        </span>
                    </div>
                </div>
                <div className="container">
                    <BlockHeader title="Recent Research" link={{
                        pathname : "browse"
                    }}/>
                    <InitiativeSlider initiatives_args={{
                        type : 'research'
                    }} />
                </div>
                <div className="container full-w research-opportunity">
                
                    <div className="container full-h">
                        <BlockHeader title="Research Opportunity x BINUS BRIDGE" desc="Crowdbees now offers research-driven challenges from BINUS BRIDGE, ready to be tackled by BINUS students, faculty, and staff. More information about BINUS BRIDGE is available at https://binus.ac.id/bridge." link={{
                            pathname : "browse?opportunity=bridge"
                        }}/>
                        <InitiativeSlider initiatives_args={{
                            type : 'research'
                            ,platform_synced : 'Bridge'
                        }} />
                    </div>
                </div>

                <div className="container relative">
                    <div className="relative list-by-filter">
                        <Sidebar>
                            <div className="filters-boxes">
                                <div className="filter-box">
                                    <div className="wrapper">
                                        <span className="filter-title">
                                            Target Output
                                        </span>
                                        <div className="filter-body">
                                            <ul className="filter-items">
                                                {

                                                    researchByTarget.map(target => (
                                                        <li key={target[0]} className={`leading-text filter-item ${target[0] == basedTargetList && 'active'}`}><a href="#"  onClick={(e) => {
                                                            e.preventDefault();

                                                            setBasedTargetList(target[0]);
                                                        }} >{target[1]}</a></li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Sidebar>
                        <div>
                            <BlockHeader title="Target Research Product" desc="Research based on the outputs produced" link={{
                                pathname : "browse" 
                            }}/>
                            {
                                researchByTarget.map(target => (
                                    target[0] == basedTargetList &&
                                    <InitiativeSlider key={target[0]} initiatives_args={{
                                        research_metadata : true
                                        ,target_product : target[0]
                                        ,type : 'research'
                                    }} />
                                ))
                            }
                        </div>
                    </div>
                </div>
                <div className="container relative">
                    <div className="relative list-by-filter">
                        <Sidebar>
                            <div className="filters-boxes">
                                <div className="filter-box">
                                    <div className="wrapper">
                                        <span className="filter-title">
                                            Research Fields
                                        </span>
                                        <div className="filter-body">
                                            <ul className="filter-items">
                                                {

                                                    researchField !== false && researchField.map(field => (
                                                        <li key={field.ResearchFieldID} className={`leading-text filter-item ${field.ResearchFieldID == basedFieldList && 'active'}`}><a href="#"  onClick={(e) => {
                                                            e.preventDefault();

                                                            setBasedFieldList(field.ResearchFieldID);
                                                        }} dangerouslySetInnerHTML={{__html : field.FieldName }}></a></li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Sidebar>
                        <div>
                            <BlockHeader title="Research Fields" desc="Research by the field" link={{
                                pathname : "browse" 
                            }}/>
                            {
                                researchField !== false && researchField.map(field => (
                                    field.ResearchFieldID == basedFieldList &&
                                    <InitiativeSlider key={field.ResearchFieldID} initiatives_args={{
                                        research_metadata : true
                                        ,research_field : field.ResearchFieldID
                                        ,type : 'research'
                                    }} />
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>

            <Footer/>
        </>
    )
}

export default PageBrowseResearch;